import { i as indent, r as outdent, t as BaseIndentPlugin } from "../src-D0aWCAGB.js";
import { toPlatePlugin, useEditorRef } from "platejs/react";
import { c } from "react-compiler-runtime";

//#region src/react/IndentPlugin.tsx
const IndentPlugin = toPlatePlugin(BaseIndentPlugin);

//#endregion
//#region src/react/hooks/useIndentButton.ts
const useIndentButton = () => {
	const $ = c(2);
	const editor = useEditorRef();
	let t0;
	if ($[0] !== editor) {
		t0 = { props: {
			onClick: () => {
				indent(editor);
			},
			onMouseDown: _temp$1
		} };
		$[0] = editor;
		$[1] = t0;
	} else t0 = $[1];
	return t0;
};
function _temp$1(e) {
	e.preventDefault();
}

//#endregion
//#region src/react/hooks/useOutdentButton.ts
const useOutdentButton = () => {
	const $ = c(2);
	const editor = useEditorRef();
	let t0;
	if ($[0] !== editor) {
		t0 = { props: {
			onClick: () => {
				outdent(editor);
			},
			onMouseDown: _temp
		} };
		$[0] = editor;
		$[1] = t0;
	} else t0 = $[1];
	return t0;
};
function _temp(e) {
	e.preventDefault();
}

//#endregion
export { IndentPlugin, useIndentButton, useOutdentButton };